import { ModalStackReturnType } from 'ui';
import { useModalsStack } from 'ui/Hooks';

import { AddStudentModalStack } from './types';

const useAddStudentModalStack = (): {
  stack: ModalStackReturnType<AddStudentModalStack>;
} => {
  const stack = useModalsStack([
    AddStudentModalStack.AddStudent,
    AddStudentModalStack.StudentAdded,
  ]);

  return { stack };
};

export { useAddStudentModalStack };
